import React, { Fragment } from 'react';

import { googleFontInfo } from '../../helpers';

const FontPreload = () => {
  return (
    <Fragment>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      {googleFontInfo.map(({ stylesheet }) => (
        <link href={stylesheet} rel="stylesheet" />
      ))}
    </Fragment>
  );
};

export default FontPreload;
